// WHAT: Shared types and context for layout
// WHY:  Keep React components in .tsx file only for fast-refresh rule

import { createContext } from "react";

/**
 * @public
 *
 */
// eslint-disable-next-line import/no-unused-modules -- Reason: This interface is exported for external use and type checking, even if not directly imported in other modules.
export interface LayoutState {
  /** Function to set sidebar open state */
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  /** Whether sidebar is open */
  sidebarOpen: boolean;
}

export const LayoutContext = createContext<LayoutState | undefined>(undefined);
